"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyChatBubble = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
const chat_styles_1 = require("@/components/domains/chat/chat.styles");
require("@/components/common");
/**
 * 내가 보낸 메시지 버블. 우측 정렬 + primary 색상.
 * 전송 상태(전송됨/읽음)를 표시합니다.
 */
let MyChatBubble = class MyChatBubble extends (0, chat_helpers_1.withChatBubbleImage)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.status = '';
    }
    render() {
        return (0, chat_helpers_1.renderChatBubbleShell)(this, (0, lit_1.html) `
        <slot></slot>
        ${this.renderStatus()}
      `);
    }
    renderStatus() {
        if (!this.status)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text class="status" role="status">${this.status}</mm-text>
    `;
    }
};
MyChatBubble.styles = [chat_styles_1.chatBubbleStyles, chat_styles_1.myChatBubbleStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MyChatBubble.prototype, "status", void 0);
MyChatBubble = __decorate([
    (0, decorators_js_1.customElement)('mm-my-chat-bubble')
], MyChatBubble);
exports.MyChatBubble = MyChatBubble;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXktY2hhdC1idWJibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJteS1jaGF0LWJ1YmJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBK0M7QUFDL0MscURBQTJEO0FBRTNELHlFQUFtRztBQUNuRyx1RUFBNEY7QUFFNUYsK0JBQTRCO0FBRTVCOzs7R0FHRztBQUVJLElBQU0sWUFBWSxHQUFsQixNQUFNLFlBQWEsU0FBUSxJQUFBLGtDQUFtQixFQUFDLGdCQUFVLENBQUM7SUFBMUQ7O1FBRXVCLFdBQU0sR0FBRyxFQUFFLENBQUE7SUFtQnpDLENBQUM7SUFqQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxvQ0FBcUIsRUFDMUIsSUFBSSxFQUNKLElBQUEsVUFBSSxFQUFBOztVQUVBLElBQUksQ0FBQyxZQUFZLEVBQUU7T0FDdEIsQ0FDRixDQUFBO0lBQ0gsQ0FBQztJQUVPLFlBQVk7UUFDbEIsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFaEMsT0FBTyxJQUFBLFVBQUksRUFBQTs4Q0FDK0IsSUFBSSxDQUFDLE1BQU07S0FDcEQsQ0FBQTtJQUNILENBQUM7O0FBbkJNLG1CQUFNLEdBQUcsQ0FBQyw4QkFBZ0IsRUFBRSxnQ0FBa0IsQ0FBQyxDQUFBO0FBQzFCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs0Q0FBWTtBQUY1QixZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxtQkFBbUIsQ0FBQztHQUN0QixZQUFZLENBcUJ4QjtBQXJCWSxvQ0FBWSJ9